import { extend } from 'sk-ui/lib/utils/util.js'

import compatibleRecord from './metaData/compatibleRecord'
import reportQry from './metaData/reportQry'
export default {
  showCompatibleDetail({ commit }, params) {
    const props = {
      params: {
        compatibleId: params.row.id
      }
    }

    const compatibleRecordCopy = extend(true, {}, compatibleRecord)
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: compatibleRecordCopy,
      props,
      drawerProps: {
        title: '【' + params.row.compatibleObjName + '】的兼容性信息',
        class: 'wsp-case-relation-drawer-55'
      }
    })
  },
  showCompatibleRelation({ commit }, row) {
    const props = {
      params: {
        id: row.fuzzyCollectCompatibleIds
      }
    }

    const reportQryCopy = extend(true, {}, reportQry)
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: reportQryCopy,
      props,
      drawerProps: {
        title: '【' + row.compatibleObjName + '】相近的兼容性案例',
        class: 'wsp-case-relation-drawer-70'
      }
    })
  }
}
